import { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getEstablishmentList as getEstablishmentListApi  } from '../../helpers/establishment/backend_helper';
import { createSelector } from 'reselect';

const useEstablishmentAssignationUser = () => {
    const dispatch = useDispatch();
    const [establishments, setEstablishments] = useState([]);
    const [establishmentsListSelect, setEstablishmentListSelect] = useState([]);

    const getEstablishment = async () => {
		try {
			const response = await getEstablishmentListApi(
                {
                    establishment_ids: (
                        user?.establishment_ids?.length
                            ?
                                user
                                    .establishment_ids
                                    .map(item => item)
                                    .join()
                            :
                                '[]'
                    )
                }
            );
            const establishmentItemsSelect = (
                response
                    ? (
                        response.map(item => {
                            return {
                                value: item._id,
                                label: item.name,
                                item: {
                                    ...item,
                                    is_default: (
                                        user.establishment_ids
                                        .find(
                                            establishment =>
                                            establishment.establishment_id == user.establishment_active_id
                                        )
                                        ? true : false
                                    )
                                }
                            }
                        })
                    )
                    : []
            )
			setEstablishments(response);
            setEstablishmentListSelect(establishmentItemsSelect);
		} catch (err) {
			switch (err.status) {
				default:
					console.log(err.message);
			}
		}
	};

    const selectorProfile = createSelector(
        state => state.Profile,
        profile => ({
            user: profile.user
        })
    );

    const { user } = useSelector(selectorProfile);

    useEffect(() => {
        if(user.establishment_assignations){
            getEstablishment();
        }
    }, [user])

    return { establishments, establishmentsListSelect, user };
};

export default useEstablishmentAssignationUser;